<h3 mat-dialog-title class="border-bottom">
  <div class="mb-4" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="6px">
    <div class="h2 font-size-22 font-weight-700 dialog-title-color"> {{title}} </div>
  </div>
</h3>
<div>
  <h3 class="border-bottom">
    <div [innerHTML]="message"></div>
  </h3>
  <div class="pt-4" fxLayoutGap="32px" fxLayoutAlign="end center">
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">OK</button>
  </div>
</div>
